import * as ActionAuth from '../../action/Auth';
import * as ActionLogin from '../../../module/Login/Store';

import { Modal, message } from 'antd';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import axios from 'axios';
import moment from 'moment';

export function* S_downloadTicket(action: any) {
  const state = yield select();
  const token = state.Auth.Token;
  const config = {
    Authorization: `bearer ${token}`,
    'Content-type': 'application/json',
  };
  const key = 'download';
  const TicketId = state.Complaint.complaintProperties.complaintId;
  const TicketCode = state.Complaint.complaintTicketCode;
  const DetailWaybill = state.Complaint.complaintWaybillDetail;
  const DateNow = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  const statusTokenRefresh = state.Auth.StatusTokenRefresh;
  function ResponseDownload(data: any) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    const file_name = `#${TicketCode} ${DetailWaybill} ${DateNow}.pdf`;
    link.href = url;
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    link.click();
  }
  try {
    const { data } = yield call(
      axios.post,
      `${process.env.REACT_APP_URL}/Complaint/DownloadInvestigasiPdf`,
      {
        id: TicketId,
      },
      {
        responseType: 'blob',
        headers: config,
        onDownloadProgress: (progressEvent: any) => {
          const { loaded, total } = progressEvent;
          const percentProgress = Math.floor((loaded * 100) / total);

          if (percentProgress < 100) {
            message.loading({
              content: `Loading ${percentProgress}%`,
              key,
            });
          } else if (percentProgress === 100) {
            Modal.destroyAll();
            message.success({
              content: 'Download Berhasil',
              key,
              duration: 1.5,
            });
          } else if (percentProgress === Infinity) {
            Modal.destroyAll();
            message.error({
              content: 'Download Gagal',
              key,
              duration: 3,
            });
          }
        },
      }
    );
    ResponseDownload(data);
    if (statusTokenRefresh === true) {
      yield put(ActionAuth.changeStatusTokenRefresh(false));
    }
  } catch (error) {
    if (error.response.data.Message === 'Network Error') {
      message.error({
        content: 'Download Gagal',
        key,
        duration: 3,
      });
    } else if (error.response.data.Message === 'No delivery found!') {
      message.error({
        content: 'Tiket tidak tersedia',
        key,
        duration: 3,
      });
    } else {
      yield put(ActionLogin.errorHandling(action, error));
    }
  }
}

export function* SM_downloadTicket() {
  yield takeLatest('DOWNLOAD_TICKET', S_downloadTicket);
}
